import { useEffect, useRef, useState } from "react";
import { Menu, Xmark } from "iconoir-react";
import { PRIMARY_NAV } from "../../shared/seo/navigation";
import { ThemeToggle } from "./ThemeToggle";

export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const header = useRef<HTMLElement>(null);

  // The panel covers the top of the page, so anything that means "I'm done with it"
  // closes it: Escape, a tap outside, or following one of its own links (which
  // navigates and remounts the header anyway).
  useEffect(() => {
    if (!open) return undefined;
    function onKeyDown(event: KeyboardEvent): void {
      if (event.key === "Escape") setOpen(false);
    }
    function onPointerDown(event: PointerEvent): void {
      if (!header.current?.contains(event.target as Node)) setOpen(false);
    }
    window.addEventListener("keydown", onKeyDown);
    window.addEventListener("pointerdown", onPointerDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
      window.removeEventListener("pointerdown", onPointerDown);
    };
  }, [open]);

  return (
    <header className="site-header" ref={header} data-menu-open={open ? "true" : undefined}>
      <a className="brand" href="/" aria-label="Nonogram Now home">
        <span className="brand-mark" aria-hidden="true">
          <i /> <i /> <i /> <i />
        </span>
        <span className="brand-name">
          <span className="brand-name-full">Nonogram Now</span>
          <span className="brand-name-short" aria-hidden="true">Nonogram</span>
        </span>
      </a>
      <div className="header-actions">
        {/* One list, two shapes: a row on a wide screen, a panel under the header on a
            phone. The links keep their full names in the panel — the cramped "Collect"
            and "How" abbreviations only ever existed to fit four links across 375px. */}
        <nav className={open ? "site-nav is-open" : "site-nav"} id="site-menu" aria-label="Primary navigation">
          {PRIMARY_NAV.map((link) =>
            link.short && link.labelClass ? (
              <a className={link.className} href={link.href} aria-label={link.label} key={link.href}>
                <span className={`${link.labelClass}-full`}>{link.label}</span>
                <span className={`${link.labelClass}-short`} aria-hidden="true">{link.short}</span>
              </a>
            ) : (
              <a className={link.className} href={link.href} key={link.href}>{link.label}</a>
            ),
          )}
        </nav>
        <ThemeToggle />
        <button
          className="menu-button"
          type="button"
          aria-expanded={open}
          aria-controls="site-menu"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((value) => !value)}
        >
          {open
            ? <Xmark width={22} height={22} strokeWidth={2} aria-hidden="true" />
            : <Menu width={22} height={22} strokeWidth={2} aria-hidden="true" />}
        </button>
      </div>
    </header>
  );
}
